import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../../components/SectionFormContainer'
import GroomingProfileWizardContext from './GroomingProfileWizardContext'
import { COATS_CONFIG, DOG_COATS, GROOMING_PROFILE_KEYS } from './constants'
import useGroomingProfile from './hooks/useGroomingProfile'
import { getAllowedGroomingServicesForPet } from './helpers'

const CoatType = (props) => {
	const {
		wizardContextProvider: { wizard_state, setWizardAttributeAndValues }
	} = useContext(GroomingProfileWizardContext)
	const { attr, title = '', subtext = '' } = props
	const { loading } = useGroomingProfile()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...wizard_state }
			const { coat_length, grooming_level } = COATS_CONFIG[type] || {
				coat_length: '',
				grooming_level: ''
			}
			newValues[GROOMING_PROFILE_KEYS.coat_type] = type
			newValues[GROOMING_PROFILE_KEYS.coat_length] = coat_length
			newValues[GROOMING_PROFILE_KEYS.grooming_level] = grooming_level

			const allowed_grooming_services = getAllowedGroomingServicesForPet(grooming_level)
			newValues[GROOMING_PROFILE_KEYS.allowed_grooming_services] = allowed_grooming_services

			setWizardAttributeAndValues(newValues)
		},
		[wizard_state, setWizardAttributeAndValues, attr]
	)

	const options = useMemo(() => {
		const o = DOG_COATS.map(({ label, src, type, description }) => {
			return {
				title: label,
				image: src,
				description,
				disabled: loading || wizard_state[attr] === type,
				selected: wizard_state[attr] === type,
				onSelected: () => handleSelection(type)
			}
		})

		return o
	}, [handleSelection, loading, wizard_state, attr])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default CoatType
